import useFetchAndStoreGlobalFilterableTaxonomyData from '@/graphql-fragments/useFetchAndStoreGlobalFilterableTaxonomyData'
import useFetchAndStorePrimaryFocusMap from '@/graphql-fragments/useFetchAndStorePrimaryFocusMap'
import React from 'react'
import { PageType } from '@/types/models/PageType.model'

type Props = {
  children: React.ReactNode
  value: {
    breadcrumbs: string | string[]
    pageType: PageType
  }
}

export const AppContext = React.createContext({
  pageType: 'unknown',
  breadcrumbs: 'unknown'
})

export const AppContextProvider = ({
  children,
  value
}: Props): React.JSX.Element => {
  const { breadcrumbs, pageType } = value
  useFetchAndStoreGlobalFilterableTaxonomyData()
  useFetchAndStorePrimaryFocusMap()
  return (
    <AppContext.Provider
      value={{
        breadcrumbs: Array.isArray(breadcrumbs)
          ? breadcrumbs.reverse().join(', ')
          : breadcrumbs,
        pageType
      }}
    >
      {children}
    </AppContext.Provider>
  )
}
